import { Component, OnInit, Renderer2 } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { Router, Event, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AppTexts } from './objects/app-static-texts';
import { CustomService } from './services/custom.service';
import { AppManagementService } from './services/app-management.service';
import { GoogleAnalyticsEventsService } from './services/google-analytics-events.service';

export let browserRefresh = false;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  
  tangent_gaId = 'G-CW5YDT5Z52';
  isMobile: boolean;
  isTablet: boolean;
  isDesktopDevice: boolean;
  poweredByEnabled: boolean = false;

  poweredbyUrl: string = "https://tangent.ai/";

  iframe_counter:number =0;

  pageToLoad: any;
  invalidIdCheckMessage: boolean = true;
  capture_iframe_msg: () => void;

  constructor(
    public appService: AppManagementService,
    private router: Router,
    private deviceDetector: DeviceDetectorService,
    public customService: CustomService,
    private gaService: GoogleAnalyticsEventsService,
    private locationStrategy: LocationStrategy,
    private renderer: Renderer2
  ) {
    // ADDING GENERAL GA ID
    this.gaService.loadGA(this.tangent_gaId);

    // FIND DEVICE TYPE
    this.detectDevice();

    router.events
    .pipe(filter((routerEvent: Event) => routerEvent instanceof NavigationEnd))
    .subscribe(() => window.scrollTo(0, 0));  
    // For adding the version url for final submit
    this.appService.ui_app_version = this.locationStrategy.getBaseHref();
  }

  ngOnInit(): void {
    this.getParamsFromUrl();
    var cookie_status=false;
    var url_status=false;
    setTimeout(() => { this.updateIframeHeight(); }, 300);
    this.capture_iframe_msg = this.renderer.listen('window', "message", event =>{
      var data_message = event["data"];
      if(data_message!=null && data_message!=undefined && typeof data_message == "string"){
        if(data_message.includes("tangent_cookie")){
          cookie_status = true;
          this.appService.parent_cookie = data_message.replace("tangent_cookie:", "");
        }
        if(data_message.includes("tangent_client_url")){
          url_status = true;
          this.appService.parent_url = data_message.replace("tangent_client_url:", "");
        }
        if(cookie_status && url_status){
          this.capture_iframe_msg();
        }
      }
    });
    setTimeout(() => {
      this.capture_iframe_msg();
    }, 10000);
  }
  

  onActivate(event) {
    let scrollToTop = window.setInterval(() => {
        let pos = window.pageYOffset;
        if (pos > 0) {
            window.scrollTo(0, pos - 20); // how far to scroll on each step
        } else {
            window.clearInterval(scrollToTop);
        }
    }, 16);
  }

  getParamsFromUrl() {
    this.customService.openLoadingDialog('start_screen');
    var loadQuiz = true;
    this.router.events.subscribe((e) => {
      
      if (e instanceof NavigationEnd) {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);

        const shop_id = urlParams.get('shop_id');
        const form_id = urlParams.get('form_id');
        
        if(shop_id!=null && form_id!=null){
          // Close existing popups
          this.customService.closeDialog();
          this.invalidIdCheckMessage = false;

          const quiz_type = urlParams.get('quiz_type');
          if(quiz_type!=null){
            this.appService.setQuizType(quiz_type);
          }

          const preview = urlParams.get('preview');
          if(preview!=null){
            if(preview=="true" || preview){
              this.appService.setPreviewQuizStatus(true)
            }
          }

          const user_email = urlParams.get('user_email');
          if(user_email!=null && user_email !=undefined){
            this.appService.setLoggedInUserEmail(user_email)
          }
          
          // Setting shop and form id as global
          this.customService.setShopId(shop_id);
          this.customService.setFormId(form_id);
          
          if(loadQuiz){
            loadQuiz = false;
            this.getClientAppJSON(shop_id, form_id);
          }
        }
        else{
          this.customService.closeDialog();
          this.showParamsError();
        }
      }
    });
  }

  // CLIENT APP JSON CALL FUNCTION
  getClientAppJSON(shop_id, form_id){
    this.appService.getClientDesignJson(shop_id, form_id).subscribe(
      (data: {}) => {
        // ANALYTICS DATA
        var analystics_config = data[AppTexts.configJSONKEY].analytics;

        // SAVE CLIENT QUIZ JSON IN GLOBAL
        this.appService.saveQuizJSON(data);

        if(analystics_config!=undefined){
          if(this.appService.previewQuiz==false){
            // ADDING CLIENT GA ID
            if(analystics_config.google.measurement_id !=undefined){
              this.gaService.loadGA(analystics_config.google.measurement_id);
            }

            // Google User Property setting
            this.gaService.setUserProperty(analystics_config.google.client_name);

            // ENABLE IF FORM ID NEED TO BE SENT
            var session_data = {
              "client": analystics_config.google.client_name,
              "form_id": form_id
            }
            this.customService.fetchSession(session_data);
            
          }
          this.navigateToScreen();
          
          // UTM Link Creation For PoweredBy Text
          this.poweredbyUrl = this.poweredbyUrl + '?utm_source='+analystics_config.google.client_name;
        
        }
        
        // Enable / Disable poweredby text
        this.poweredByEnabled = this.appService.enablePoweredBy();
        
      },
      (error: {}) => {
        console.log("error", error);
      }
    );
  }

  navigateToScreen(){
    if(this.appService.getPageDesign()!=undefined){
      // Navigate to first screen
      var linkUrl = "/" + this.appService.getPageDesign().name;
      this.router.navigate([linkUrl], { queryParamsHandling: 'preserve' });
    }
  }

  // TO IDENTIFY TYPE OF DEVICE
  detectDevice() {
    const isMobile = this.deviceDetector.isMobile();
    const isTablet = this.deviceDetector.isTablet();
    const isDesktopDevice = this.deviceDetector.isDesktop();
    this.appService.setDeviceType(isMobile, isTablet, isDesktopDevice);
  }

  // OPEN PARAMS MISSING ERROR POPUP
  showParamsError(){
    setTimeout(() => {
      if (this.invalidIdCheckMessage) {
        this.customService.closeDialog();
        var dialogue_title = $localize`Sorry something went wrong!`;
        var dialogue_msg = $localize`Please refresh or try again later!`;
        var message = { title: dialogue_title, message: dialogue_msg };
        this.customService.openMessageDialog(message);
      }
    }, 4000);
  }

  ngOnDestroy(): void { this.customService.closeDialog(); }
  
  updateIframeHeight(){
    var ele = document.getElementById('router-container');
    if(ele!=null && ele!=undefined){
      var offsetHeight = ele.offsetHeight;
      this.appService.sentHeight(offsetHeight);
    }
  }


}